//@flow

// Vendors
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Route, Switch } from 'react-router';
import { ConnectedRouter as Router } from 'connected-react-router';
import { history } from '../store';

// Actions
import { getSession } from '../reducers/auth/authActions';

// Layouts
import {
  DefaultPrivateLayout,
  DefaultPublicLayout,
  TermsConditionsLayout,
  TakeoverLayout,
  BasicPublicLayout,
  BasicPrivateLayout,
} from '.';

// Types
type Props = {
  isAuthenticated: boolean,
  profile: Object,
  getSession: Function,
};

class LayoutBase extends Component<Props> {
  componentDidMount() {
    const { isAuthenticated, profile, getSession } = this.props;
    if (!isAuthenticated || !profile) getSession();
  }

  render() {
    return (
      <Router history={history}>
        <Switch>
          <Route exact path="/" component={BasicPublicLayout} />
          <Route exact path="/es" component={BasicPublicLayout} />
          <Route path="/agency/:agencySlug?" component={DefaultPrivateLayout} />
          <Route path="/history/:type?" component={DefaultPrivateLayout} />
          <Route path="/account" component={DefaultPrivateLayout} />
          <Route path="/link" component={TakeoverLayout} />
          {/* for employee dashboard */}
          <Route path="/employee" component={DefaultPrivateLayout} />
          {/* for listing apps under employee agency*/}
          <Route
            path="/employee/:agencySlug?"
            component={DefaultPrivateLayout}
          />
          <Route path="/bnlr" component={TakeoverLayout} />
          <Route path="/dpslr" component={TakeoverLayout} />
          <Route path="/tdlrlr" component={TakeoverLayout} />
          <Route path="/tpwdas" component={TakeoverLayout} />
          <Route path="/dmvrr" component={TakeoverLayout} />
          <Route path="/dmv/edit-renewal-notice" component={TakeoverLayout} />
          <Route path="/dmv/sticker-tracker" component={TakeoverLayout} />
          <Route path="/cybersecurity" component={TakeoverLayout} />
          <Route path="/reverify" component={TakeoverLayout} />
          <Route exact path="/sign-in" component={BasicPublicLayout} />
          <Route
            exact
            path="/es/dmv/renovacion-registro-vehiculo"
            component={BasicPublicLayout}
          />
          <Route
            exact
            path="/dmv/vehicle-registration-renewal"
            component={BasicPublicLayout}
          />
          <Route
            exact
            path="/dps/driver-license-id-renewal-replacement"
            component={BasicPublicLayout}
          />
          <Route
            exact
            path="/es/dps/renovacion-licencia-de-conducir"
            component={BasicPublicLayout}
          />
          <Route
            exact
            path="/es/tdlr/renovacion-licencia-de-terapia-masaje"
            component={BasicPublicLayout}
          />
          <Route
            exact
            path="/tdlr/massage-therapy-license-renewals"
            component={BasicPublicLayout}
          />
          <Route
            exact
            path="/tpwd/boat-services"
            component={BasicPublicLayout}
          />
          <Route
            exact
            path="/es/tpwd/servicios-de-embarcación"
            component={BasicPublicLayout}
          />

          <Route path="/getting-started" component={BasicPrivateLayout} />
          <Route path="/create-account" component={DefaultPublicLayout} />
          <Route path="/forgot-password" component={DefaultPublicLayout} />
          <Route path="/forgot-username" component={DefaultPublicLayout} />
          <Route path="/terms-conditions" component={TermsConditionsLayout} />
          <Route component={DefaultPrivateLayout} />
        </Switch>
      </Router>
    );
  }
}

const mapStateToProps = ({
  auth: { isAuthenticated },
  user: { profile },
}): Object => ({ isAuthenticated, profile });
const mapDispatchToProps = (dispatch: Object) =>
  bindActionCreators({ getSession }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LayoutBase);
